import { render, staticRenderFns } from "./QuarterBox.vue?vue&type=template&id=1f05ab6a&scoped=true&"
import script from "./QuarterBox.vue?vue&type=script&lang=js&"
export * from "./QuarterBox.vue?vue&type=script&lang=js&"
import style0 from "./QuarterBox.vue?vue&type=style&index=0&id=1f05ab6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05ab6a",
  null
  
)

export default component.exports